import React, { memo } from "react";
import { Icon, IconProps } from "@chakra-ui/icon";

const ItalicIcon = (props: IconProps) => (
  <Icon width="20px" height="20px" viewBox="0 0 20 20" {...props}>
    <path d="M8.33333 3.33337v2.5H10.175L7.325 12.5H5V15h6.6667v-2.5H9.825l2.85-6.66663H15v-2.5H8.33333Z" />
  </Icon>
);

export default memo(ItalicIcon);
